import '../scss/claimHistory.scss'
import LoadingPage from '../reusableComponents/loader/loadingPage';
import NoDataFound from '../utilsComponent/noDataFound';
import { format } from 'date-fns';
import { Accordion } from 'react-bootstrap';
const LossReserveTrail = (props) => {
    const { lossReserveAuditList } = props;
    return (
        <div className='inner-box2Field start-0 w-100 mt-4' style={{ height: "auto", top: "auto" }}>
            {
                <div>
                    <Accordion defaultActiveKey={["0"]} alwaysOpen>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Loss Reserve Trail</Accordion.Header>
                            <Accordion.Body>
                                {
                                        lossReserveAuditList && lossReserveAuditList.length > 0 ? (
                                            <div className="row">
                                                    <div className="overflowHistory lossReserveScrollBar">
                                                        <table id="claim_historyclaim" className="table table-strip mt-0">
                                                            <thead>
                                                                <tr>
                                                                    <th>Sl No.</th>
                                                                    <th className='activityTime'>Activity Time</th>
                                                                    <th className='description'>Description</th>
                                                                    <th>Old LR%</th>
                                                                    <th>New LR%</th>
                                                                    <th>Updated By</th>
                                                                    <th>Ownership</th>
                                                                    <th>Trigger</th>
                                                                    <th className='reasonColumn'>Reason</th>
                                                                    <th className='reasonColumn'>Remarks</th>
                                                                    <th>LR Amount(₹)</th>
                                                                    <th>Amount Disbursed(₹)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    lossReserveAuditList && lossReserveAuditList?.length > 0 && lossReserveAuditList?.map((list, index) => (
                                                                        <tr key={index}>
                                                                            <td >{lossReserveAuditList.length - index}</td>
                                                                            <td className='activityTime'>{format(new Date(list.createdDate), 'dd-MM-yyyy, hh:mm a')}</td>
                                                                            <td className='description'>{list.description}</td>
                                                                            <td >{list.oldLossReserve.toFixed(2)}%</td>
                                                                            <td >{list.newLossReserve.toFixed(2)}%</td>
                                                                            <td >{list.createdBy}</td>
                                                                            <td >{list.ownership}</td>
                                                                            <td >{list.trigger}</td>
                                                                            <td className="reasonColumn">{list.reason}</td>
                                                                            <td className="reasonColumn">{list.remarks}</td>
                                                                            <td >₹ {list.lossReserveAmount.toFixed(2) }</td>
                                                                            <td >₹ {list.amountDisbursed.toFixed(2)}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                            </div>
                                        ) : <NoDataFound text="No Loss Reserve Trail Found" />
                                }
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>

            }
        </div>
    )
}

export default LossReserveTrail
